import createFiltersStore from '../../../../stores/createFiltersStore'
import { DEFAULT_BILLING_FILTERING } from '../../../../utils/constants'

export const useBillingFiltersStore = createFiltersStore(
    'activeBillingFilters',
    DEFAULT_BILLING_FILTERING
)
